<ul>
  <mat-radio-group class="question-level__form__radio" [name]="radioGroupName" (change)="onSelected($event)">
    <li *ngFor="let response of responses">
      <fieldset>
        <legend hidden>{{ 'user.interests.title' | translate }}</legend>
        <mat-radio-button
          #radioButton
          [checked]="userResponsesCurrentLevel.includes(response.uuid)"
          [name]="radioGroupName"
          [value]="response.uuid"
          >{{ response.text }}</mat-radio-button
        >
      </fieldset>
      <app-radio-question-level
        [question]="question"
        [level]="level + 1"
        [responses]="response.formResponseDTOList"
        *ngIf="radioButton.checked && !!response.formResponseDTOList"></app-radio-question-level>
    </li>
  </mat-radio-group>
</ul>
